import React, { useEffect, useState } from 'react';
import { ContentReason, ContentSteps, HeaderSteps, TitleReason, TitleSteps } from '../styles';
import { useRetentionSignature } from '../../../../hooks/RetentionSignatureContext';
import { ArrowLeft, ArrowRight } from '../svgs';
import { Radio } from '@bancobarigui/barihaus';
import { acceptanceType } from '../../../../enums/retention-reasons.enum';
import SignatureService from '../../../../services/SignatureService';
import logger from '../../../../utils/logger.utils';
import { Button } from '../../../../components/UISignatue/Button';
import { Container, ContainerButton } from '../Footer/styles';

export const RetentionReason: React.FC = () => {
  const { setStep, retentionReason, setRetentionReason, formOpened, setFormOpened, nextStep, setErrorSignature } =
    useRetentionSignature();
  const [selectedReason, setSelectedReason] = useState(retentionReason || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handlePrevstep = () => {
    setStep((previousStep: any) => previousStep - 1);
  };

  const handleReasonChange = (value: string) => {
    setSelectedReason(value);
    setRetentionReason(value);
    setIsButtonDisabled(false);
    // Update formOpened with acceptanceType
    setFormOpened({
      ...formOpened,
      acceptanceType: value,
    });
  };

  const handleConfirm = async (e: any) => {
    e.preventDefault();

    if (!selectedReason) {
      return;
    }

    try {
      setIsSubmitting(true);

      // Send a single request with the proposal contract (signature by token)
      const proposalContract = {
        latitude: formOpened.customerLatitude,
        longitude: formOpened.customerLongitude,
        ip: formOpened.customerIP,
        token: formOpened.token,
        acceptanceType: formOpened.acceptanceType,
        document: formOpened.documentNumber,
      };
      const response = await SignatureService.acceptPortabilityRetentionContract(proposalContract);

      if (response.status !== 200 && response.status !== 202 && response.status !== 204) {
        logger.error('Falha ao enviar proposta de retenção:', response);
        throw new Error('Error Signature - Failed to submit retention proposal');
      }

      nextStep(e);
    } catch (err: any) {
      logger.error('Erro ao enviar propostas de retenção:', err);
      setErrorSignature(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    // Disable button if no reason is selected
    setIsButtonDisabled(!selectedReason);
  }, [selectedReason]);

  const acceptanceTypeOptions = [
    { label: 'Eu não solicitei a portabilidade', value: acceptanceType.NOT_REQUESTED },
    {
      label: 'Solicitei a portabilidade, mas desisti do pedido',
      value: acceptanceType.CANCELLED_REQUEST,
      className: 'mt-2',
    },
    {
      label: 'Recebi do(a) banco Bari uma proposta melhor e desisti de realizar a portabilidade',
      value: acceptanceType.BETTER_PROPOSAL_BARI,
      className: 'mt-2',
    },
  ];

  return (
    <>
      <ContentSteps>
        <HeaderSteps>
          <button onClick={handlePrevstep}>
            <ArrowLeft />
          </button>
          <TitleSteps>Motivo da permanência</TitleSteps>
        </HeaderSteps>
        <ContentReason>
          <TitleReason>
            Que bom que você vai continuar com a gente! Para concluirmos, selecione o principal motivo da sua decisão:
          </TitleReason>
          <Radio.Group
            options={acceptanceTypeOptions}
            name="retention-reason"
            value={selectedReason}
            onChange={(e: any) => handleReasonChange(e.target.value)}
          />
        </ContentReason>
      </ContentSteps>

      {/* Custom Footer */}
      <Container className="fixed">
        <ContainerButton>
          <Button
            black
            big
            spaced
            onClick={handleConfirm}
            iconRight={ArrowRight}
            disabled={isButtonDisabled || isSubmitting}
          >
            {isSubmitting ? 'Enviando...' : 'Confirmar'}
          </Button>
        </ContainerButton>
      </Container>
    </>
  );
};
